import React from 'react';
import styled from 'styled-components';
import { colors } from '_styles';
import { _ } from '_locales';
import HOC from '_HOC';

import { Map } from '../../DepoEvent/DepoEvents_Components';

const Container = styled.div`
    width: 100%;
    margin: 0 auto;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    min-height: 350px;
`;

const Title = styled.h2`
    color: #000;
    font-size: 20px;
    font-weight: 400;
    text-align: left;
    font-family: Roboto, sans-serif;
    margin-bottom: 40px;
`;

const ZoneTitle = styled.h4`
    font-size: 14px;
    color: #747474;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    margin-bottom: 14px;
`;

const ZoneContent = styled.p`
    padding: 0;
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
`;

const ConfirmZone = styled.button`
  color: #fff;
  width: 160px;
  height: 39px;
  border: none;
  display: flex;
  font-size: 14px;
  padding: 20px 0;
  cursor: pointer;
  position: relative;
  border-radius: 8px;
  align-items: center;
  margin: 40px auto 15px;
  justify-content: center;
  background-color: ${colors.RC_ACTION};
`;

const CorrectZone = styled.button`
  border: none;
  display: flex;
  font-size: 12px;
  cursor: pointer;
  margin: 0px auto;
  position: relative;
  align-items: center;
  justify-content: center;
  color: ${colors.RC_ACTION};
  background-color: transparent;
  `;

const ListContainer = styled.div`
  margin-bottom: 25px;
`;

const ConfirmLocation = ({ zone, props }) => {
  const {
    prompts, zoneAry, fullAddress, coordinate
  } = zone;

  const { history } = props;

  const locationStatus = () => {
    if (
      prompts
      && prompts.length
      && !prompts[0].zoneSelectOptions.map
      && prompts[0].zoneSelectOptions.list
    ) {
      const address = fullAddress.split(',');

      return (
        <>
          {
            zoneAry.map((value, index) => (
              <ListContainer key={`${value}@${prompts[index].name}`}>
                <ZoneTitle>{prompts[index].name}</ZoneTitle>
                <ZoneContent>{address[index]}</ZoneContent>
              </ListContainer>
            ))
          }
        </>
      );
    }

    if (
      prompts
        && prompts.length
        && prompts[0].zoneSelectOptions.map
    ) {
      return (
        <>
          <ZoneTitle>{_('help.your_address')}</ZoneTitle>
          <ZoneContent>{fullAddress}</ZoneContent>
          <br />
          <ZoneTitle>{_('zone.your_location')}</ZoneTitle>
          <Map
            latLng={{ lat: coordinate.lat, lng: coordinate.lng }}
            mapElement={<div style={{ width: '100%', height: '300px' }} />}
            loadingElement={<div style={{ width: '100%', height: '300px' }} />}
            containerElement={<div style={{ width: '100%', height: '300px' }} />}
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places`}
          />
        </>
      );
    }

    return (
      <>
        <ZoneTitle>{_('zone.your_location')}</ZoneTitle>
        <ZoneContent>{fullAddress}</ZoneContent>
      </>
    );
  };

  return (
    <Container>
      <Title>{_('help.ok_lets_start_by_confirm_these_details')}</Title>
      {locationStatus()}
      <ConfirmZone onClick={() => history.push('/help/missed-collections')}>{_('help.correct')}</ConfirmZone>
      <CorrectZone onClick={() => history.push('/help/description-page', {
        title: _('help.update_your_zone'),
        zoneButton: _('help.go_to_zone_setup'),
        description: _('help.wrong_zone_setup'),
      })}
      >
        {_('help.its_not_correct')}
      </CorrectZone>
    </Container>
  );
};

export default HOC(ConfirmLocation);
